export const env = {
  gaiaUrl: import.meta.env.VITE_GAIA_API_URL,
} as const
